<div class="container">
    <div class="card-create" *ngIf="properties.variant === getCardVariant('MM_CREATE')">
        <fcp-icon [icon]="properties.icon" [style]="'color:var(--text-11);font-size:var(--text-size-4xl)'"></fcp-icon>
        <label>{{ properties.label }}</label>
    </div>
    <div class="card-placeholder" *ngIf="properties.variant === getCardVariant('MM_PLACEHOLDER')">
        <label>{{ properties.label }}</label>
    </div>
</div>
